/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import analytics from "../analytics/analytics";
import baustein from "baustein";
import { selectors as appHeaderSelectors } from "./app-header-menu";
import { events as calloutEvents } from "components/app-header-callout";
const componentName = "encouraged-search";

const productTypeOptionsComponentName = "product-type-options";
const categoryOptionsComponentName = "category-options";
const categorySearchComponentName = "category-search";

const selectors = {
    FOCUSED_ELEMENT_CLASS_NAME: `${componentName}__element--focused`,
    FORM: `.${componentName}__form`,
    GENDER: '[name="gender-switch"]',
    GENDER_INPUT: '[name="gender-switch"]:checked',
    PRODUCT_TYPE_CHECKED_INPUT: "input[name='product_type']:checked"
};

export default baustein.register(componentName, {
    setupEvents(add) {
        // listening to change instead of click gender switch input button because in ios,
        // you cannot click a div inside a label. The trick to fix that is by adding
        // pointer-events: none which doesn't trigger the click event of the button.
        add("change", selectors.GENDER, this._toggleGender);
        add("brandChanged", this._brandChanged);
        add("submit", selectors.FORM, this._handleSubmit);
        add("openedDropDown", this._closeOtherDropDown);
        add("openedDropDown", this._elementFocused);
        add("productTypeChanged", this._productTypeChanged);
        add("categoryChanged", this._categoryChanged);
        add("categorySearchChanged", this._categorySearchChanged);
        add("categorySearchCloseClicked", this._categorySearchCloseClicked);
        add("brandSearchInputClicked", this._elementFocused);
        add("brandSearchInputClicked", this._send_brand_focus_analytics);
        add("inputBlurred", this._onBlur);
    },

    onInsert() {
        this.setGlobalHandler("scroll", this._checkIfScrolledPast);
        // we only want to send this once
        this.sentBrandFocusEvent = false;
    },

    /**
     * Checks if we've scrolled past encouraged search component
     * sends analytics event if we have
     */
    _checkIfScrolledPast() {
        const { bottom } = this.el.getBoundingClientRect();
        const headerBar = document.querySelector(appHeaderSelectors.HEADER_BAR)
            ? document.querySelector(appHeaderSelectors.HEADER_BAR)
            : document.querySelector(appHeaderSelectors.HEADER_BAR_SIMPLIFIED);

        const headerHeight = headerBar.offsetHeight;

        if (bottom <= headerHeight) {
            analytics.event("encouraged search", "Scrolled Past", null, true);
            this.releaseGlobalHandler("scroll", this._checkIfScrolledPast);
        }
    },

    _closeOtherDropDown(event) {
        [
            productTypeOptionsComponentName,
            categoryOptionsComponentName,
            categorySearchComponentName
        ].forEach(componentName => {
            const component = this.findComponent(componentName);

            if (component && event.target !== component) {
                component.closeDropDown();
            }
        });
    },

    closeDropDownsAndBlurElements() {
        [
            productTypeOptionsComponentName,
            categoryOptionsComponentName,
            categorySearchComponentName
        ].forEach(componentName => {
            const component = this.findComponent(componentName);
            if (component) {
                component.closeDropDown();
            }
        });
        this._blurElements();
    },

    _updateTaxonomyOptions(selectedGender, selectedProductType) {
        const taxonomyMap = this.options.taxonomyMap;

        const productTypeOptionsComponent = this.findComponent(productTypeOptionsComponentName);
        const categoryOptionsComponent = this.findComponent(categoryOptionsComponentName);

        productTypeOptionsComponent.updateProductTypeOptions(
            taxonomyMap,
            selectedGender,
            selectedProductType
        );
        categoryOptionsComponent.updateCategoryOptions(
            taxonomyMap,
            selectedGender,
            selectedProductType
        );
    },

    async _productTypeChanged(event) {
        const selectedGender = this._getActiveGender();
        this._updateTaxonomyOptions(selectedGender, event.selectedProductType);

        this._closeOverlay();
        await analytics.event("encouraged search", "changed", "product_type");
    },

    async _categoryChanged(event) {
        const taxonomyMap = this.options.taxonomyMap;
        const selectedGender = this._getActiveGender();
        const selectedProductType =
            this.el.querySelector(selectors.PRODUCT_TYPE_CHECKED_INPUT).value || null;

        const categoryOptionsComponent = this.findComponent(categoryOptionsComponentName);
        categoryOptionsComponent.updateCategoryOptions(
            taxonomyMap,
            selectedGender,
            selectedProductType,
            event.selectedCategory
        );

        this._closeOverlay();
        await analytics.event("encouraged search", "changed", "category");
    },

    async _categorySearchChanged() {
        this._closeOverlay();
        await analytics.event("encouraged search", "changed", "category search");
    },

    _categorySearchCloseClicked() {
        this._closeOverlay();
    },

    async _brandChanged() {
        this._closeOverlay();
        this._blurElements();
        await analytics.event("encouraged search", "changed", "brand_search");
    },

    _onBlur() {
        this._closeOverlay();
    },

    _closeOverlay() {
        this.emit(calloutEvents.CLOSE_LYST_MATTE);
    },

    _blurElements() {
        this.el.querySelectorAll(`.${selectors.FOCUSED_ELEMENT_CLASS_NAME}`).forEach(element => {
            element.classList.remove(selectors.FOCUSED_ELEMENT_CLASS_NAME);
        });
    },

    async _toggleGender() {
        const targetGender = this._getActiveGender();

        const brandSearch = this.findComponent("encouraged-search-brand-search");
        if (brandSearch) {
            brandSearch.onGenderChange(targetGender);
        }

        const categorySearch = this.findComponent("category-search");
        if (categorySearch) {
            categorySearch.onGenderChange(targetGender);
        } else {
            const selectedProductType =
                this.el.querySelector(selectors.PRODUCT_TYPE_CHECKED_INPUT).value || null;
            this._updateTaxonomyOptions(targetGender, selectedProductType);
        }

        await analytics.event("encouraged search", "changed", "gender");
    },

    /**
     * Gets the current active Gender constant "M" or "F"
     *
     * @returns {string}
     */
    _getActiveGender() {
        return document.querySelector(selectors.GENDER_INPUT).value;
    },

    _elementFocused(event) {
        this.emit(calloutEvents.OPEN_LYST_MATTE_WITH_SCROLL);
        let element = event.target.el;
        element.classList.add(selectors.FOCUSED_ELEMENT_CLASS_NAME);
    },

    _send_brand_focus_analytics() {
        if (this.sentBrandFocusEvent) {
            return;
        }
        this.sentBrandFocusEvent = true;
        analytics.event("encouraged search", "focused", "brand");
    },

    /**
     * Send analytics event and submit the form
     */
    async _handleSubmit(event) {
        event.preventDefault();
        await analytics.event("encouraged search", "search");
        event.target.submit();
    }
});

